import { Component, Input, input } from '@angular/core';

@Component({
  selector: 'app-arrow-button',
  template: `
    <span
      ><img
        id="overlayImage"
        src="/assets/img/loader-sm.gif"
        class="spinner"
        [style.display]="isLoading() ? 'inline-block' : 'none'"
    /></span>
    <span>{{ text }}</span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      viewBox="0 0 129 129"
      enable-background="new 0 0 129 129"
      width="129px"
      height="129px"
      [class]="getArrowClass()"
    >
      <g>
        <path
          d="m40.4,121.3c-0.8,0.8-1.8,1.2-2.9,1.2s-2.1-0.4-2.9-1.2c-1.6-1.6-1.6-4.2 0-5.8l51-51-51-51c-1.6-1.6-1.6-4.2 0-5.8 1.6-1.6 4.2-1.6 5.8,0l53.9,53.9c1.6,1.6 1.6,4.2 0,5.8l-53.9,53.9z"
          fill="#A9A9A9"
        />
      </g>
    </svg>
  `,
  styleUrls: ['./arrow-button.component.scss'],
  standalone: true,
  host: {
    type: 'button',
    tabindex: '0',
    '(click)': 'onClick()',
  },
})
export class ArrowButtonComponent {
  @Input() text: string;
  @Input() onClick: () => void;
  @Input() isOpen: boolean;
  public isLoading = input(false);

  public getArrowClass() {
    const result = 'arrow';
    if (this.isOpen) {
      return `${result} arrow-open`;
    }
    return result;
  }
}
